import React, { useContext, useState } from "react";

import { Link } from "react-router-dom";
import { Card } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const ShortLinkIcon = (props) => {
  return (
    <>
      <Link to={props.link}>
        <Card className="menu-card shadow-none">
          <CardContent className="p-0 rounded h-100">
            <Typography
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={props.icon}
                className="mt-2"
                style={{ width: "47px" }}
              />
            </Typography>
            <div className="text-center text-black mt-2">{props.title}</div>
          </CardContent>
        </Card>
      </Link>
    </>
  );
};
export default ShortLinkIcon;
